import { useRef, useEffect } from "react";
import { Image as KonvaImage, Transformer } from "react-konva";

export type ImageAttr = {
  id: string;
  image: HTMLImageElement;
  x: number;
  y: number;
  width: number;
  height: number;
  originalWidth: number;
  originalHeight: number;
}


type Props = {
imageAttr: ImageAttr,
  isSelected: boolean,
  onSelect: () => void,
  onChange: (newAttr: ImageAttr) => void
}

const ImageLayer = ({ onChange, imageAttr, isSelected, onSelect }: Props) => {

  const imageRef = useRef<any>(null);
  const trRef = useRef<any>(null);

  useEffect(() => {
    if (isSelected && trRef.current && imageRef.current) {
      trRef.current.nodes([imageRef.current]);
      trRef.current.getLayer()?.batchDraw();
    }
  }, [isSelected]);

  return (
    <>
      <KonvaImage
        ref={imageRef}
        onClick={onSelect}
        onTap={onSelect}
        image={imageAttr.image}
        x={imageAttr.x}
        y={imageAttr.y}
        width={imageAttr.width}
        height={imageAttr.height}
        draggable
        onDragEnd={(e) => {
          onChange({
            ...imageAttr,
            x: e.target.x(),
            y: e.target.y(),
          });
        }}
        onTransformEnd={() => {
          const node = imageRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          node.scaleX(1);
          node.scaleY(1);
          
          onChange({
            ...imageAttr,
            x: node.x(),
            y: node.y(),
            width: Math.max(20, node.width() * scaleX),
            height: Math.max(20, node.height() * scaleY),
          });
        }}
        hitStrokeWidth={20}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 20 || newBox.height < 20) return oldBox;
            return newBox;
          }}
          rotateEnabled={true}
          keepRatio={true}
          anchorSize={12}
          borderStroke="#10b981"
          borderStrokeWidth={2}
        />
      )}
    </>
  )
}

export default ImageLayer;
